import { render, staticRenderFns } from "./CreateAssignment.vue?vue&type=template&id=4e5503a7&scoped=true&"
import script from "./CreateAssignment.vue?vue&type=script&lang=js&"
export * from "./CreateAssignment.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssignment.vue?vue&type=style&index=0&id=4e5503a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5503a7",
  null
  
)

export default component.exports